module.exports = __webpack_public_path__ + "img/pic__photo_01@2x.3d45e308.png";